/**
 * Plan-mode workspace home (`/plan/w/:slug`). The mental model: a workspace is a
 * FOLDER of canvases + artifacts (it grants access to datasets + people and is
 * where work happens) — NOT a project. So its Plan page mirrors the Work-mode
 * workspace overview (canvases grid + artifacts list) via the shared
 * WorkspaceOverview. The org-wide rollup of projects + objectives lives at
 * `/plan/all-work`; structured Plan entities (projects, objectives) have their
 * own workspace-independent detail routes (`/plan/p/:slug`, `/plan/o/:slug`).
 */

import { createFileRoute, useParams } from "@tanstack/react-router";

import { WorkspaceOverview } from "@/components/workspace/WorkspaceOverview";

export const Route = createFileRoute("/_app/plan/w/$slug")({
  component: PlanWorkspaceHome,
});

function PlanWorkspaceHome() {
  const { slug } = useParams({ from: "/_app/plan/w/$slug" });
  return <WorkspaceOverview slug={slug} section="Plan" />;
}
